import axios from 'axios'
import http from '@/services/http'

let cancelManufacturesByCitySrc = null

/**
 * Используется отдельно в компонентах для установки
 * производства в локалсторадж перед переходом на страницы
 * посредством контекстного меню (только для супер юзеров)
 * @param { id: number, title: string, city_id: number, coordinates: { lat: number, lng: number } } manufacture 
 */
export const saveManufactureLocStorage = manufacture => {
  localStorage.setItem('selectedManufacture', JSON.stringify(manufacture))
}

export default {
  namespaced: true,
  state: {
    cities: [],
    selectedCity: null,
    selectedAreas: [],
    selectedManufacture: null,
    /**
     * для установки временного id производства,
     * при переходе с одного роута на другой
     * который будет использоваться в запросе, 
     * обязательго нужно следить, после отправки запроса, 
     * производство обнуляается. Используется, например 
     * при переходе на страницу заказа со страниц в которых 
     * может не быть еще производства (const/shared-pages.js)
     * 
     */
    routeManufactureId: null
  },
  getters: {
    areaList(state) {
      if (state.selectedCity) {
        return state.selectedCity.areas
      }
      return []
    },
    manufacturesList(state) {
      if (state.selectedCity) {
        return state.selectedCity.areas
          .reduce((acc, area) => {
            return [ ...acc, ...area.manufactures]
          }, [])
          .sort((a, b) => {
            const aStr = a.title
            const bStr = b.title
            return aStr < bStr ? -1 : (aStr > bStr ? 1 : 0)
          })
      }
      return []
    },
    areasIds(state) {
      return state.selectedAreas.map(area => area.area_id).join(',')
    }
  },
  mutations: {
    SET_CITIES(state, cities) {
      state.cities = cities
    },
    SET_SELECTED_AREAS(state, selectedAreas) {
      state.selectedAreas = selectedAreas
    },
    SET_SELECTED_CITY(state, selectedCity) {
      state.selectedCity = selectedCity
    },
    SET_SELECTED_MANUFACTURE(state, selectedManufacture) {
      saveManufactureLocStorage(selectedManufacture)
      state.selectedManufacture = selectedManufacture
    },
    SET_ROUTE_MANUFACTURE_ID(state, routeManufactureId) {
      state.routeManufactureId = routeManufactureId
    }
  },
  actions: {
    async getCities({ commit }) {
      const res = await http.get('cities')
      commit('SET_CITIES', res)
    },
    async getManufacturesByCity({ state }) {
      if (cancelManufacturesByCitySrc) {
        cancelManufacturesByCitySrc.cancel()
      }
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()

      cancelManufacturesByCitySrc = source
      /**
       * Этот запрос используется в send-to-gain-modal модалке,
       * которая может быть отображена только у админов. У адмистраторов
       * не устанавливается selectedCity в app.js, поскольку нет списков городов,
       * поэтому делаем через проверку
       */
      const cityId = state.selectedCity ? state.selectedCity.id : state.selectedManufacture.city_id
      const res = await http.get(`cities/${cityId}/manufactures`, {
        cancelToken: source.token
      })
      return res
    },

    setManufactureAreasChange({ state, commit }) {
      const areasManufactures = state.selectedAreas.reduce((acc, area) => {
        return [ ...acc, ...area.manufactures ]
      }, [])
      if (
          areasManufactures.length &&
          (!state.selectedManufacture || areasManufactures.find(manufacture => {
            return manufacture.id === state.selectedManufacture.id
          }) === undefined)
        ) {
          commit('SET_SELECTED_MANUFACTURE', areasManufactures[0])
        }
    },

    setSelectedCity({ commit, dispatch }, city) {
      commit('SET_SELECTED_CITY', city)
      if (city) {
        dispatch('setSelectedAreas', city.areas)
      }
    },

    setSelectedAreas({ commit, dispatch }, selectedAreas) {
      commit('SET_SELECTED_AREAS', selectedAreas)
      dispatch('setManufactureAreasChange')
    }
  }
}